/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';
import { service } from '@ember/service';
import Scopes from '@linc-technologies/linced-common/enums/scopes';
import { classNames } from '@ember-decorators/component';

@classNames('tree-node', 'layout-row', 'layout-align-start-start')
export default class TreeNode extends Component {
  Scopes = Scopes;

  @service
  permissions;

  labelProperty = 'label';
  itemSingular = 'Item';
  icon = 'insert-drive-file';
}
